import { Grid2 as Grid, IconButton, Stack } from "@mui/material"
import Button from "@mui/material/Button"
import { Field, Formik, useFormikContext } from "formik"
import { useCallback, useMemo } from "react"
import * as yup from "yup"
import { Sequenza } from "../../types"
import { transformErrorForForm } from "../../utils/utils"
import { FormInDialogProps } from "../DialogForm"
import { FormikTextField } from "./formsHelpers"
import { useTranslation } from "react-i18next"
import { formatSeconds } from "../../utils/video"
import FilterCenterFocusIcon from '@mui/icons-material/FilterCenterFocus';

type SetTimeButtonProps = {
  valueName: string
  getCurrentTime?: () => number
}

function SetTimeButton({ valueName, getCurrentTime }: SetTimeButtonProps) {
  const { setFieldValue } = useFormikContext()
  const handleSetTcIn = useCallback(() => {
    if (!getCurrentTime) {
      return
    }
    const currentTime = getCurrentTime()
    if (currentTime) {
      const formattedTime = formatSeconds(currentTime)
      setFieldValue(valueName, formattedTime)
    }
  }, [getCurrentTime, setFieldValue, valueName])
  return (
    <IconButton
      onClick={handleSetTcIn}
      size="small"
      
    >
      <FilterCenterFocusIcon />
    </IconButton>
  )
}

type SequenzaFormProps = FormInDialogProps<Sequenza> & {
  getCurrentTime?: () => number
}
export default function SequenzaForm({ item, save, ref, getCurrentTime }: SequenzaFormProps) {
  const { t } = useTranslation()
  const initialValues = useMemo(() => {
    return (
      item ?? {
        tcin: "",
        tcout: "",
        descrizione_it: "",
        descrizione_en: "",
        note: "",
      }
    )
  }, [item])

  const schema = useMemo(() => yup.object().shape({}), [t])

  return (
    <Formik
      validationSchema={schema}
      initialValues={initialValues}
      enableReinitialize
      onSubmit={(values, formikBag) => {
        return save(values as Sequenza).catch((e) => {
          const localError = transformErrorForForm(e)
          formikBag.setErrors(localError)
        })
      }}
    >
      {({ handleSubmit }) => {
        return (
          <form onSubmit={handleSubmit} noValidate>
            <Grid container spacing={1} sx={{ py: 2 }}>
              <Grid size={8}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Field
                    name="tcin"
                    label={t("sequenza.tcin")}
                    component={FormikTextField}
                    margin="dense"
                    variant="outlined"
                    fullWidth
                  />
                  {getCurrentTime && <SetTimeButton valueName="tcin" getCurrentTime={getCurrentTime} />}
                </Stack>
              </Grid>

              <Grid size={8}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Field
                    name="tcout"
                    label={t("sequenza.tcout")}
                    component={FormikTextField}
                    margin="dense"
                    variant="outlined"
                    fullWidth
                  />
                  {getCurrentTime && <SetTimeButton valueName="tcout" getCurrentTime={getCurrentTime} />}
                </Stack>
              </Grid>

              <Grid size={12}>
                <Field
                  name="descrizione_it"
                  label={t("sequenza.descrizione_it")}
                  
                  component={FormikTextField}
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  multiline
                  minRows={6}
                />
              </Grid>
              <Grid size={12}>
                <Field
                  name="descrizione_en"
                  label={t("sequenza.descrizione_en")}
                  component={FormikTextField}
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  multiline
                  minRows={6}
                />
              </Grid>

              <Grid size={12}>
                <Field
                  name="note"
                  label={t("general.note")}
                  component={FormikTextField}
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  multiline
                  minRows={6}
                />
              </Grid>
            </Grid>

            <Button ref={ref} type="submit" color="primary" sx={{ display: "none" }}></Button>
          </form>
        )
      }}
    </Formik>
  )
}
